import { api } from "./api";
import type { OnrampPayload, OnrampResponse } from "../../types/OnrampTypes";

export const onrampApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getOnramps: builder.query<OnrampResponse, void>({
      query: () => ({
        url: "/onramps/",
      }),
      providesTags: ["Onramps"],
    }),
    updateOnramp: builder.mutation<OnrampResponse, OnrampPayload>({
      query: (payload) => ({
        url: "/onramps/",
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["Onramps"],
    }),
  }),
});

export const { useGetOnrampsQuery, useUpdateOnrampMutation } = onrampApi;
